import MediaService from '../../services/MediaService'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useRef, useState } from 'react'
import { API } from 'aws-amplify'

import './ListeningPractice.scss'
import { GetUserVideo, getVideo } from '../../s3Func/s3Download'
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat'
import { sleep } from '../../utils'

/**
 *  Creates and runs the practice section for Unit1 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const ListeningPractice = ({
	world2,
	setDisplayPractice,
	module,
	onPracticeClose,
	background,
	stepComplete,
}) => {
	// Initialize variables and states here
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)
	const dispatch = useDispatch()

	const [introVideo, setIntroVideo] = useState(null)
	const [displayIntroVideo, setDisplayIntroVideo] = useState(null)
	const [displayPracticeImages, setDisplayPracticeImages] = useState(false)
	const [pageData, setPageData] = useState({})
	const [practiceCount, setPracticeCount] = useState(0)
	const [displayTalkingDog, setDisplayTalkingDog] = useState(false)

	const [image1, setImage1] = useState(null)
	const [image2, setImage2] = useState(null)
	const [image3, setImage3] = useState(null)
	const [image4, setImage4] = useState(null)
	const [image0_0, setImage0_0] = useState(false)
	const [image0_1, setImage0_1] = useState(false)
	const [image1_0, setImage1_0] = useState(false)
	const [image1_1, setImage1_1] = useState(false)

	const [image1BounceOut, setImage1BounceOut] = useState(false)
	const [image2BounceOut, setImage2BounceOut] = useState(false)
	const [image3BounceOut, setImage3BounceOut] = useState(false)
	const [image4BounceOut, setImage4BounceOut] = useState(false)

	const [correctImage1, setCorrectImage1] = useState(null)
	const [correctImage2, setCorrectImage2] = useState(null)
	const [score, setScore] = useState(0)

	const [gamePaused, setGamePaused] = useState(false)

	const XImage = MediaService.getImage('/Module2Images/redX.png', login)
	const Exit = MediaService.getImage('/Images/close.png', login)
	const tryAgain = MediaService.getVideo('/Module2Videos/ah_oh.mp3', login)
	const boingSound = MediaService.getVideo('/Module1Videos/button_accept_item.mp3',login)
	const yeahSound = MediaService.getVideo('/Module2Videos/kids_yeah.m4a', login)

	const getIntroductionVideo = async () => {
		let videoData
		const isModule7 = stepComplete === 'MODULE7_SET_stepCompleted'

		if (module.currentday === 1) {
			videoData = isModule7
				? 'Module7/practice_day_1.mp4'
				: 'Module2Videos/practice_day_1.mp4'
		} else if (module.currentday === 2) {
			videoData = isModule7
				? 'Module7/practice_day_2.mp4'
				: 'Module2Videos/practice_day_2.mp4'
		} else if (module.currentday === 3) {
			// 'c9030ca2400a29637ed7d7289d1f/480.m3u8'
			videoData = isModule7
				? 'Module7/practice_day_3.mp4'
				: 'Module2Videos/practice_day_3.mp4'
		} else {
			videoData = await GetUserVideo(
				`influencers/${login.influencerid}/listening_video_message.mp4`
			)
		}

		setIntroVideo(videoData)
		setDisplayIntroVideo(true)
	}

	const handleIntroVideoEnded = () => {
		setDisplayIntroVideo(false)
		randomizeImages();
		setDisplayPracticeImages(true)
	}

	const downloadVideos = async () => {
		let data = {
			images: {
				makingEyeContact: [],
				notMakingEyeContact: [],
			},
			sound: {},
			gif: {},
		}

		const notMakingEyeContactPhotos = [
			'appfiles/listening/day-1-photo-look-away.jpg',
			'appfiles/listening/day-2-photo-look-away.jpg',
			'appfiles/listening/day-3-photo-look-away.jpg',
			'appfiles/listening/day-1-photo-look-away-2.jpg',
			'appfiles/listening/day-2-photo-look-away-2.jpg',
			'appfiles/listening/day-3-photo-look-away-2.jpg',
		]

		const makingEyeContactPhotos = [
			'appfiles/listening/day-1-photo-2-looking.jpg',
			'appfiles/listening/day-2-photo-3-looking-eyes.jpg',
			'appfiles/listening/day-3-photo-2-looking.jpg',
			'appfiles/listening/day-1-photo-looking-2.jpg',
			'appfiles/listening/day-2-photo-looking-2.jpg',
			'appfiles/listening/day-3-photo-looking-2.jpg',
		]

		data.images.notMakingEyeContact = await Promise.all(
			notMakingEyeContactPhotos.map(async (url) => getVideo(url, login))
		)

		data.images.makingEyeContact = await Promise.all(
			makingEyeContactPhotos.map(async (url) => getVideo(url, login))
		)

		data.gif.amazingJobDog = getVideo('appfiles/listening/dog_amazing.gif', login)
		data.sound.amazingJobDog = getVideo('appfiles/listening/dog_amazing_job.mp3', login)

		data.sound.reviewQuestion = getVideo('appfiles/listening/review_listening_question.mp3', login)

		if (stepComplete === 'MODULE7_SET_stepCompleted') {
			data.sound.listeningQuestion = getVideo('appfiles/listening/review_listening_question.mp3', login)
		} else {
			data.sound.listeningQuestion = getVideo('appfiles/listening/listening_question.mp3', login)
		}

		setPageData(data)
	}

	// Generate a random number, then decide a random arrangement of photos for practice based on it.
	const randomizeImages = () => {
		let rand1, rand2, rand3, rand4
		let image1Url, image2Url, image3Url, image4Url
		const { floor, random } = Math

		const randomNum = floor(random() * 4)

		while (rand1 === rand2 || rand3 === rand4) {
			rand1 = floor(random() * 5)
			rand2 = floor(random() * 5)
			rand3 = floor(random() * 5)
			rand4 = floor(random() * 5)
		}

		image1Url = pageData && pageData.images.makingEyeContact[rand1]
		image2Url = pageData && pageData.images.makingEyeContact[rand2]
		image3Url = pageData && pageData.images.notMakingEyeContact[rand3]
		image4Url = pageData && pageData.images.notMakingEyeContact[rand4]
		setCorrectImage1(1)
		setCorrectImage2(2)

		if (randomNum === 1) {
			image1Url = pageData && pageData.images.makingEyeContact[rand2]
			image2Url = pageData && pageData.images.notMakingEyeContact[rand3]
			image3Url = pageData && pageData.images.notMakingEyeContact[rand4]
			image4Url = pageData && pageData.images.makingEyeContact[rand1]
			setCorrectImage1(1)
			setCorrectImage2(4)
		}

		if (randomNum === 2) {
			image1Url = pageData && pageData.images.notMakingEyeContact[rand3]
			image2Url = pageData && pageData.images.makingEyeContact[rand2]
			image3Url = pageData && pageData.images.notMakingEyeContact[rand4]
			image4Url = pageData && pageData.images.makingEyeContact[rand1]
			setCorrectImage1(2)
			setCorrectImage2(4)
		}

		if (randomNum === 3) {
			image1Url = pageData && pageData.images.notMakingEyeContact[rand4]
			image2Url = pageData && pageData.images.notMakingEyeContact[rand3]
			image3Url = pageData && pageData.images.makingEyeContact[rand2]
			image4Url = pageData && pageData.images.makingEyeContact[rand1]
			setCorrectImage1(3)
			setCorrectImage2(4)
		}

		setImage1(image1Url)
		setImage2(image2Url)
		setImage3(image3Url)
		setImage4(image4Url)
	}

	const pauseGame = async () => {
		setGamePaused(true)
		await sleep(1500)
		setGamePaused(false)
	}

	const gameLogic = (imageNum, crossImage) => {
		const bounceSound = new Audio(boingSound)
		const tryAgainAudio = new Audio(tryAgain)
		if (!gamePaused) {
			if (imageNum === correctImage1 || imageNum === correctImage2) {
				pauseGame()
				bounceSound.play()
				crossImage(false)
				setPracticeCount(practiceCount + 1)
				setScore(score + 1)
				doAnimation(imageNum)
			} else {
				setScore(score - 1)
				pauseGame()
				crossImage(true)
				tryAgainAudio.play()
			}
		}
	}

	const doAnimation = (imageNum) => {
		if (imageNum === 1) {
			setImage1BounceOut(true)
		} else if (imageNum === 2) {
			setImage2BounceOut(true)
		} else if (imageNum === 3) {
			setImage3BounceOut(true)
		} else if (imageNum === 4) {
			setImage4BounceOut(true)
		}
	}

	const handleAudioEnded = () => {
		if (!module.reviewIcon) {
			dispatch({ type: stepComplete, payload: 'practice' })
		}
		if (world2) {
			setDisplayPractice(false)
		}
		else{
			onPracticeClose();
		}
		setDisplayTalkingDog(false)
	}

	// Decide which video to play for practice based on the day, then download videos
	useEffect(() => {
		getIntroductionVideo()
		downloadVideos()
	}, [])

	const saveToDB = () => {
		const payload = {
			body: {
				student_id: login.studentid,
				metric: 'practice_listening',
				result: JSON.stringify({
					day: module.currentday,
					created: new Date().toISOString(),
					review: world2 ? 1 : 0,
					values: [{ value: score, target: 2 }],
				}),
			},
		}
		try {
			API.post('TIR', '/v3/student/result', payload)
		} catch (error) {
			console.log(error)
		}
	}

	const endAnimation = () => {
		let playYeahSound = new Audio(yeahSound)
		playYeahSound.play()
		sleep(1500).then(() => {
			setDisplayPracticeImages(false)
			setDisplayTalkingDog(true)
		})
	}

	useEffect(() => {
		if (practiceCount) {
			if (practiceCount === 2) {
				saveToDB()
				setPracticeCount(0)
				endAnimation()
			}
		}
	}, [practiceCount])

	// ==================== iOS Detection ====================
	const isIOS = () => {
		return [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod'
		].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	useEffect(() => {
		let timer;
		if (displayTalkingDog && isIOS()) {
			timer = setTimeout(() => {
				handleAudioEnded()
			}, 5000)
		}
		return () => {
			if (timer) clearTimeout(timer);	
		}
	}, [displayTalkingDog])

	// The HTML code for the practice section
	return (
		<>
			{displayIntroVideo && (
				<CloudfrontVideoFormat
					source={introVideo}
					back="/listening"
					close={() => {
						if (world2) {
							setDisplayPractice(false)
						}
						else{
							onPracticeClose();
						}
						setDisplayIntroVideo(false)
						
					}}
					background={background}
					ended={handleIntroVideoEnded}
				/>
			)}
			<div
				className="listening-practice"
				style={{ backgroundImage: `url(${background})` }}
			>
				<header>
					<button>
						<img
							alt=""
							src={Exit}
							onClick={() => {
								if (world2) {
									setDisplayPractice(false)
								}
								onPracticeClose();
							}}
						/>
					</button>
				</header>
				{displayPracticeImages && (
					<main>
						<audio
							autoPlay
							src={pageData.sound.listeningQuestion}
						/>
						<h2 style={{ color: 'blue' }}>Who is listening by making eye contact? Select two correct photos.</h2>

						<div className="listening-practice-grid">
							{/* question audio handled by effect and always-mounted audio */}
							<button>
								{image0_0 && <img className="red-cross" src={XImage} alt="" />}
								<img
									className={image1BounceOut ? 'bounce-out' : undefined}
									src={image1}
									alt=""
									onClick={() => gameLogic(1, setImage0_0)}
								/>
							</button>
							<button>
								{image0_1 && <img className="red-cross" src={XImage} alt="" />}
								<img
									src={image2}
									className={image2BounceOut ? 'bounce-out' : undefined}
									alt=""
									onClick={() => gameLogic(2, setImage0_1)}
								/>
							</button>
							<button>
								{image1_0 && <img className="red-cross" src={XImage} alt="" />}
								<img
									className={image3BounceOut ? 'bounce-out' : undefined}
									src={image3}
									alt=""
									onClick={() => gameLogic(3, setImage1_0)}
								/>
							</button>
							<button>
								{image1_1 && <img className="red-cross" src={XImage} alt="" />}
								<img
									src={image4}
									className={image4BounceOut ? 'bounce-out' : undefined}
									alt=""
									onClick={() => gameLogic(4, setImage1_1)}
								/>
							</button>
						</div>
					</main>
				)}

				{pageData.gif && !displayPracticeImages && (
					<>
					{displayTalkingDog && <audio autoPlay src={pageData.sound.amazingJobDog} onEnded={handleAudioEnded} />}
					<main style={{ opacity: displayTalkingDog ? 1 : 0 }}>
						<figure>
							<img
								alt=""
								className="amazing-dog"
								src={pageData.gif.amazingJobDog}
							/>
						</figure>
					</main>
					</>
				)}
			</div>
		</>
	)
}
export default ListeningPractice
